export default __webpack_public_path__ + "static/media/conver_to_BFC_transport.d7f7d107.png";